export const pageData = [
	{
		title: '组织机构',
		children: [
			{title: '指导单位', contents: ['xxxxxx局', 'xxxxxx委员会']},
			{title: '主办单位', contents: ['xxxxxx公司', 'xxxxx大学', 'xxx发展中心']},
			{title: '承办单位', contents: ['xxxxxx公司', 'xxxxx大学', 'xxx发展中心']},
			{title: '协办单位', contents: ['xxxxxx公司', 'xxxxx大学', 'xxx发展中心', 'xxxxxx', 'xxxxx']},
			{title: '支持单位', contents: ['xxxxxx', 'xxxxxx', 'xxxxx']},
			{title: '赞助单位', contents: ['xxxxxx', 'xxxxxx']},
		]
	},
	{
		title: '会议主宾',
		children: [
			{
				title: '',
				type: 'name',
				contents: [
					['高长力', '国家广播电视总局电视剧司司长',],
					['冯胜勇', '国家广播电视总局网络视听节目管理司司长',],
					['雷振宇', '吉林省委宣传部副部长',],
					['陈耀辉', '吉林省文联党组书记 主席',],
					['赵明','长春市委副书记 宣传部部长',],
					['赵志强','吉林省文联党组成员 副主席',],
					['王兴隆','吉林省委宣传部电影处处长',],
					['马学庆','吉林省委宣传部文艺处处长',],
					['刘淑燕','长春市委宣传部电影处处长',],
					['庄严','长影集团党委书记 董事长',],
					['鲍盛华','长影集团党委副书记 总经理',],
					['王亮','长影集团监事会主席',],
					['张光临','长影集团党委副书记',],
					['冷国红','长影集团纪委书记 监察专员',],
					['吕美艳','长影集团副总经理',],
					['刘威','长影集团副总经理',],
					['刚辉','长影集团副总经理',],
					['于彦硕','长影集团电影频道总监',],
					['邢蕾蕾','长影集团电影频道副总监',],
					['段振楠','长影集团电影频道总监助理',],
					['刘多','长春师范大学党委书记',],
					['王延明','长春师范大学校长',],
					['张德利','长春师范大学副校长（正厅级）',],
					['刘国宁','长春师范大学党委副书记',],
					['胡德超','长春师范大学副校长',],
					['刘鹏飞','长春师范大学副校长',],
					['徐晓辉','长春师范大学校办主任',],
					['孙凌晨','长春师范大学发展规划处处长',],
					['于龙','长春师范大学政策法规处处长',],
					['吕云峰','长春师范大学教务处处长',],
					['费龙','长春师范大学科研处处长',],
					['赵海燕','长春师范大学学生工作部部长',],
					['钟磊','长春师范大学文旅与电影学院院长',],
					['冯远征','北京人民艺术剧院院长',],
					['刘洪鹏','北京电影协会会长',],
					['吴曼芳','北京电影学院管理学院院长',],
					['宋方金','中国电影文学学会副会长',],
					['隋清红','吉林省电影家协会副主席',],
					['王瑞','北京电影学院导演系主任',],
					['王浩','中国电视剧制作中心艺术总监',],
					['韩三平','中影集团原董事长',],
					['喇培康','中影集团原董事长',],
					['黄群飞','华夏电影常务副总经理',],
					['王长田','光线传媒董事长兼总经理 猫眼娱乐董事长',],
					['刘洪涛','开心麻花影业董事长',],
					['于洲','追光动画联合创始人 总裁',],
					['马东','米未传媒创始人 CEO',],
					['代代','阿里影业CMO',],
					['嗷啸','阿里影业CTO',],
					['关旭','阿里影业副总裁',],
					['戴莹','爱奇艺高级副总裁 资深制作人',],
					['姜滨','爱奇艺副总裁',],
					['张大勇','中影数字电影发展(北京)有限公司总经理',],
					['贾尧','华策集团副总编辑',],
					['潘兆年','华策集团创意发现中心总经理',],
					['尹香今','万达影视传媒有限公司总经理',],
					['李波','西影数科总经理',],
					['吴京','知名演员 导演',],
					['王宝强','知名演员 导演',],
					['郭帆','知名导演',],
					['俞白眉','知名导演 编剧 监制',],
					['史建全','知名编剧',],
					['钱重远','制片人',],
					['刘晓世','编剧 导演',],
					['高金玺','制片人 发行人',],
					['龚格尔','编剧 制作人',],
					['侯天来','知名演员',],
					['种丹妮','知名演员',],
					['卢静','制片人',],
					['张克','国际纪录片导演',],
					['张冀','电影编剧 导演',],
					['杨惠龙','青年导演',],
					['唐江山','北京微短剧文化发展中心主任',],
					['王炎','北京创业科创科技中心主任',],
					['朱铁玉','河南鑫山集团凤凰城董事长',],
					['王辉','河南多元豫宙科技有限公司总经理',],
					['胡超','ADG亚洲数字集团董事局副主席兼总裁',],
					['刘达','祜莱控股集团董事长',],
					['李浦源','中祥集团董事长',],
					['候超','日新阅益董事长',],
					['封跃平','国樽律师事务所创始人',],
				]
			},

		]
	},
	{
		title: '会议议程',
		children: [
			{title: ' ', contents: ['13:30-14:00', '签到入场']},
			{title: ' ', contents: ['14:00-14:10', '开场语：宣布会议开始 介绍领导与嘉宾']},
			{title: ' ', contents: ['14:10-14:15', '领导致辞：指导单位领导']},
			{title: ' ', contents: ['14:15-14:20', '领导致辞：主办单位领导']},
			{title: ' ', contents: ['14:20-14:25', '领导致辞：属地政府领导',]},
			{title: ' ', contents: ['14:25-14:40', 'xxxxxxXxxxxxxxxxxx']},
			{title: ' ', contents: ['14:40-14:55', 'xxxxxxXxxxxxxxxxxx']},
			{title: ' ', contents: ['14:55-15:10', 'xxxxxxXxxxxxxxxxxx']},
			{title: ' ', contents: ['15:10-15:25', 'xxxxxxXxxxxxxxxxxx']},
			{
				title: '第一单元',
				contents: ['15:25-15:35', 'xxxxxxXxxxxxxxxxxx', ' ', ' ', '15:35-16:05', 'xxxxxxxxxxx', ' ', ' ', '16:05-16:15', '发布仪式：xxxxxxxx'],

			},
			{
				title: '第二单元',
				contents: ['15:25-15:35', 'xxxxxxXxxxxxxxxxxx', ' ', ' ', '15:35-16:05', 'xxxxxxxxxxx', ' ', ' ', '16:05-16:15', '发布仪式：xxxxxxxx'],

			},
			{
				title: '第三单元',
				contents: ['15:25-15:35', 'xxxxxxXxxxxxxxxxxx', ' ', ' ', '15:35-16:05', 'xxxxxxxxxxx', ' ', ' ', '16:05-16:15', '发布仪式：xxxxxxxx'],

			},
		]
	},
]
